import { FileUpload } from '@models/file';

export class TranslationProcessDto {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  targetLanguage: string;
  languageName: string;
  fileId;
  string;
  file: FileUpload;
  status: string;
  completed: number;
  total: number;
  finishedAt?: Date;
  blockStats?: {
    totalBlocks: number;
    translatedBlocks: number;
    staleBlocks: number;
    missingBlocks: number;
    originalCharacters: number;
    translatedCharacters: number;
  };
}

export class CreateTranslationDto {
  targetLanguage: string;
  languageName: string;
  fileId: string;
}

export class GetTranslationDto {
  id: number;
  flag: FileUpload;
  targetLanguage: string;
  languageName: string;
}
